export default () => Component(function ($context) {
	return $context.select('.form');
}, function ($form, self) {
	$.extend(self, {
		initEventListeners: function() {
			$form.on('click', '.form__btn', function(){
				$(this).closest('form').submit();
			});
		}
	});

	self.initEventListeners();
});
